import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconDocsComponent } from "./med-icon-docs.component";

@NgModule({
  declarations: [
    MedIconDocsComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconDocsComponent,
  ],
})
export class MedIconDocsModule { }
